import { render, staticRenderFns } from "./project-visualizations.vue?vue&type=template&id=3c195b8e&scoped=true"
import script from "./project-visualizations.vue?vue&type=script&lang=js"
export * from "./project-visualizations.vue?vue&type=script&lang=js"
import style0 from "./project-visualizations.vue?vue&type=style&index=0&id=3c195b8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.25_cache-loader@4.1.0_webpack@4.47.0__css-load_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c195b8e",
  null
  
)

export default component.exports